import { render, staticRenderFns } from "./BKBattle.vue?vue&type=template&id=1c64e3c7&scoped=true"
import script from "./BKBattle.vue?vue&type=script&lang=js"
export * from "./BKBattle.vue?vue&type=script&lang=js"
import style0 from "./BKBattle.vue?vue&type=style&index=0&id=1c64e3c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c64e3c7",
  null
  
)

export default component.exports